import { withStyles } from "@material-ui/core";
import React, { Component } from "react";
import { translate } from "react-i18next";
import findingService from "@Services/Findings";
import styles from "./styles";

class WatermarkIndicator extends Component {
  state = {
    watermarkInfo: [],
  };
  componentDidMount() {
    findingService.getWatermarkInfo(this.props.findingId).then((response) => {
      this.setState({ watermarkInfo: response });
    });
  }

  renderTestResults = () => {
    const { t } = this.props;

    const watermarksToRender = this.state.watermarkInfo;

    let renderedWatermarks = [];
    for (let i = 0; i < watermarksToRender.length; i++) {
      const currWatermark = watermarksToRender[i];
      renderedWatermarks.push(
        <div
          key={i}
          style={{
            color: currWatermark.hasWatermark ? "green" : "gray",
            marginLeft: i > 0 ? 10 : 0,
          }}
        >
          {i > 0 && " | "}
          <b style={{ marginLeft: i > 0 ? 5 : 0 }}>
            {currWatermark.providerName}
          </b>{" "}
          {currWatermark.hasWatermark && (
            <img
              style={{ position: "relative", top: "2px" }}
              src="/checkmark.png"
              width={14}
              height={14}
              alt="Checkmark"
            />
          )}{" "}
          {currWatermark.hasWatermark ? t("_detected") : t("_not_detected")}
        </div>,
      );
    }
    return renderedWatermarks;
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <div
          className={
            this.state.watermarkInfo.findIndex(
              (x) => x.hasWatermark === true,
            ) !== -1
              ? classes.iconGreen
              : classes.iconGray
          }
        >
          <div>
            <img
              style={{ paddingTop: 9, zIndex: 1000 }}
              src="/waves.svg"
              width={33}
              height={33}
              alt="Watermark Icon"
            />
          </div>
        </div>
        <div className={classes.hidableResults}>{this.renderTestResults()}</div>
      </div>
    );
  }
}

export default withStyles(styles)(
  translate("translations")(WatermarkIndicator),
);
